import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export default function TableTextField({
  name = '',
  type = 'text',
  value,
  onChange = false,
  hideable = false,
  editable = false,
  placeholder = '',
}) {
  const [show, setShow] = useState(!hideable);
  return (
    <TextField
      type={show ? type : 'password'}
      variant='outlined'
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      sx={textFieldStyle}
      InputProps={{
        ...(hideable && {
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton onClick={() => setShow(!show)} edge='end' size='small' tabIndex={-1}>
                {show ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }),
      }}
      disabled={!editable || !show}
    />
  );
}

const textFieldStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    '& fieldset': { border: 'none' },
    height: '100%',
  },
  '& .MuiInputBase-input': {
    padding: '6px 8px',
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: 'rgba(0,0,0,0.87)',
    opacity: 1,
  },
  '& .MuiInputBase-root.Mui-disabled': {
    color: 'rgba(0,0,0,0.6)',
    opacity: 1,
  },
  width: '100%',
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
};
